import { IQCDefectEnum, IQCDisposeEnum, IQCResEnum, QCStateEnum, QCTypeEnum } from "@/types/inventoryV2";
import { useTranslation } from "react-i18next";

type OptionsList<T> = {
  key: T;
  value: T;
  color: string;
  label: string;
}
const useIqcEnums = (addVn = false) => {
  const { t } = useTranslation();

  // 质检结果
  const IQCResEnumList: OptionsList<IQCResEnum>[] = [
    {
      key: IQCResEnum.NOT_IQC,
      value: IQCResEnum.NOT_IQC,
      color: "blue",
      label: addVn ? `${t('warehouse.toQc', { lng: "zh" })}/${t('warehouse.toQc', { lng: "vn" })}` : t('warehouse.toQc')
    },
    {
      key: IQCResEnum.PASS,
      value: IQCResEnum.PASS,
      color: "green",
      label: addVn ? `${t('warehouse.passQc', { lng: "zh" })}/${t('warehouse.passQc', { lng: "vn" })}` : t('warehouse.passQc')
    },
    {
      key: IQCResEnum.FAIL,
      value: IQCResEnum.FAIL,
      color: "red",
      label: addVn ? `${t('warehouse.failQc', { lng: "zh" })}/${t('warehouse.failQc', { lng: "vn" })}` : t('warehouse.failQc')
    },
  ];

  const getIQCRes = (value: IQCResEnum | null) => {
    if (value === null) return
    return IQCResEnumList.find(i => i.value === value)
  };

  // 质检拒绝原因
  const IQCDefectEnumList: OptionsList<IQCDefectEnum>[] = [
    {
      key: IQCDefectEnum.FRONT,
      value: IQCDefectEnum.FRONT,
      color: "magenta",
      label: addVn ? `${t('warehouse.front', { lng: "zh" })}/${t('warehouse.front', { lng: "vn" })}` : t('warehouse.front')
    },
    {
      key: IQCDefectEnum.SIZE,
      value: IQCDefectEnum.SIZE,
      color: "red",
      label: addVn ? `${t('warehouse.size', { lng: "zh" })}/${t('warehouse.size', { lng: "vn" })}` : t('warehouse.size')
    },
    {
      key: IQCDefectEnum.POWER,
      value: IQCDefectEnum.POWER,
      color: "volcano",
      label: addVn ? `${t('warehouse.power', { lng: "zh" })}/${t('warehouse.power', { lng: "vn" })}` : t('warehouse.power')
    },
    {
      key: IQCDefectEnum.PACKAGE,
      value: IQCDefectEnum.PACKAGE,
      color: "orange",
      label: addVn ? `${t('warehouse.package', { lng: "zh" })}/${t('warehouse.package', { lng: "vn" })}` : t('warehouse.package')
    },
    {
      key: IQCDefectEnum.TAG,
      value: IQCDefectEnum.TAG,
      color: "gold",
      label: addVn ? `${t('warehouse.tag', { lng: "zh" })}/${t('warehouse.tag', { lng: "vn" })}` : t('warehouse.tag')
    },
    {
      key: IQCDefectEnum.OTHER,
      value: IQCDefectEnum.OTHER,
      color: "purple",
      label: addVn ? `${t('warehouse.other', { lng: "zh" })}/${t('warehouse.other', { lng: "vn" })}` : t('warehouse.other')
    },
  ];

  const getIQCDefect = (value: IQCDefectEnum | null) => {
    if (value === null) return

    return IQCDefectEnumList.find(i => i.value === value)
  };
  // 质检处理结果
  const IQCDisposeEnumList: OptionsList<IQCDisposeEnum>[] = [
    {
      key: IQCDisposeEnum.RETURN,
      value: IQCDisposeEnum.RETURN,
      color: "red",
      label: addVn ? `${t('warehouse.dispReturn', { lng: "zh" })}/${t('warehouse.dispReturn', { lng: "vn" })}` : t('warehouse.dispReturn')
    },
    {
      key: IQCDisposeEnum.ACCEPT,
      value: IQCDisposeEnum.ACCEPT,
      color: "orange",
      label: addVn ? `${t('warehouse.dispAcpt', { lng: "zh" })}/${t('warehouse.dispAcpt', { lng: "vn" })}` : t('warehouse.dispAcpt')
    },
    {
      key: IQCDisposeEnum.REDO,
      value: IQCDisposeEnum.REDO,
      color: "geekblue",
      label: addVn ? `${t('warehouse.dispRedo', { lng: "zh" })}/${t('warehouse.dispRedo', { lng: "vn" })}` : t('warehouse.dispRedo')
    },
  ];

  const getIQCDispose = (value: IQCDisposeEnum | null) => {
    if (value === null) return
    return IQCDisposeEnumList.find(i => i.value === value)
  };

  // 质检类型
  const QCTypeEnumList: OptionsList<QCTypeEnum>[] = [
    {
      key: QCTypeEnum.INBOUND,
      value: QCTypeEnum.INBOUND,
      color: "geekblue",
      label: addVn ? `${t('warehouse.qcInbound', { lng: "zh" })}/${t('warehouse.qcInbound', { lng: "vn" })}` : t('warehouse.qcInbound')
    },
    {
      key: QCTypeEnum.OUTBOUND,
      value: QCTypeEnum.OUTBOUND,
      color: "magenta",
      label: addVn ? `${t('warehouse.qcOutbound', { lng: "zh" })}/${t('warehouse.qcOutbound', { lng: "vn" })}` : t('warehouse.qcOutbound')
    },
    {
      key: QCTypeEnum.WAREHOUSE,
      value: QCTypeEnum.WAREHOUSE,
      color: "green",
      label: addVn ? `${t('warehouse.qcWarehouse', { lng: "zh" })}/${t('warehouse.qcWarehouse', { lng: "vn" })}` : t('warehouse.qcWarehouse')
    },
    {
      key: QCTypeEnum.PROCESS,
      value: QCTypeEnum.PROCESS,
      color: "cyan",
      label: addVn ? `${t('warehouse.qcProgress', { lng: "zh" })}/${t('warehouse.qcProgress', { lng: "vn" })}` : t('warehouse.qcProgress')
    },
    {
      key: QCTypeEnum.RETURN,
      value: QCTypeEnum.RETURN,
      color: "red",
      label: addVn ? `${t('warehouse.qcReturn', { lng: "zh" })}/${t('warehouse.qcReturn', { lng: "vn" })}` : t('warehouse.qcReturn')
    },
  ];

  const getQCType = (value: QCTypeEnum | null) => {
    if (value === null) return
    return QCTypeEnumList.find(i => i.value === value)
  };

  // 质检状态
  const QCStateEnumList: OptionsList<QCStateEnum>[] = [
    {
      key: QCStateEnum.QC_TODO,
      value: QCStateEnum.QC_TODO,
      color: "magenta",
      label: addVn ? `${t('warehouse.toQc', { lng: "zh" })}/${t('warehouse.toQc', { lng: "vn" })}` : t('warehouse.toQc')
    },
    {
      key: QCStateEnum.QC_ING,
      value: QCStateEnum.QC_ING,
      color: "geekblue",
      label: addVn ? `${t('warehouse.qcIng', { lng: "zh" })}/${t('warehouse.qcIng', { lng: "vn" })}` : t('warehouse.qcIng')
    },
    {
      key: QCStateEnum.QC_PASS,
      value: QCStateEnum.QC_PASS,
      color: "green",
      label: addVn ? `${t('warehouse.passQc', { lng: "zh" })}/${t('warehouse.passQc', { lng: "vn" })}` : t('warehouse.passQc')
    },
    {
      key: QCStateEnum.QC_FAIL,
      value: QCStateEnum.QC_FAIL,
      color: "red",
      label: addVn ? `${t('warehouse.failQc', { lng: "zh" })}/${t('warehouse.failQc', { lng: "vn" })}` : t('warehouse.failQc')
    },

  ];

  const getQCState = (value: QCStateEnum | null) => {
    if (value === null) return
    return QCStateEnumList.find(i => i.value === value)
  };


  return {
    IQCResEnumList,
    getIQCRes,
    IQCDefectEnumList,
    getIQCDefect,
    IQCDisposeEnumList,
    getIQCDispose,
    QCTypeEnumList,
    getQCType,
    QCStateEnumList,
    getQCState
  }
};

export default useIqcEnums;